import {
  Box,
  Button,
  CircularProgress,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDigitalSample } from "../../hooks/digital-samples";
import { useTitle } from "../../hooks/title";
import { downloadAsset } from "../../service/download-asset";

export const DigitalSampleAssetDownloadPage = () => {
  useTitle("File Download · Imagio Color Finder");

  const { assetId, digitalSampleId } = useParams();
  const [digitalSamples] = useDigitalSample({ id: digitalSampleId }, true);
  const file = digitalSamples?.[0]?.assets.find(
    (asset) =>
      asset.id.toString() === assetId && asset.tags.includes("COMPLIANT"),
  );

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (file) {
      downloadAsset(file);
      setLoading(false);
    }
  }, [file]);

  return (
    <Stack alignItems="center" m={6} spacing={2}>
      <Typography variant={"h4"}>Download</Typography>
      <Typography>
        You have requested a download for{" "}
        <strong>{file?.fileName ?? "..."}</strong>
      </Typography>
      <Typography>
        Your Download will start <b>automatically</b> within a few seconds.
      </Typography>
      <Stack alignItems="center" justifyContent="center" height={60}>
        {loading ? (
          <CircularProgress />
        ) : (
          <Link underline="hover" href={file?.assetUrl}>
            Download the file manually.
          </Link>
        )}
      </Stack>
      <Box>
        <Button
          sx={{ mt: 4 }}
          variant="contained"
          onClick={() => window.close()}
        >
          Close this Browser Tab
        </Button>
      </Box>
    </Stack>
  );
};
